/**
 * 制作工作台 · 集数 + 场景导航
 */
import { ChevronDown } from 'lucide-react';
import type { DirectorEpisodePlan, DirectorSceneShots } from './types';

interface Props {
  episodes: DirectorEpisodePlan[];
  episodeIndex: number;
  sceneId: string | null;
  onEpisodeChange: (idx: number) => void;
  onSceneChange: (sceneId: string) => void;
}

export function EpisodeSceneNav({
  episodes,
  episodeIndex,
  sceneId,
  onEpisodeChange,
  onSceneChange,
}: Props) {
  const ep = episodes.find((e) => e.episodeIndex === episodeIndex);
  const scenes: DirectorSceneShots[] = ep?.scenes ?? [];

  return (
    <div className="flex flex-col gap-3 border-b border-outline-variant/20 bg-surface px-5 py-3">
      <div className="flex flex-wrap items-center gap-3">
        <label className="text-xs text-neutral-500">分集</label>
        <div className="relative">
          <select
            value={episodeIndex}
            onChange={(e) => onEpisodeChange(Number(e.target.value))}
            className="appearance-none rounded-md border border-outline-variant/40 bg-surface px-3 py-1.5 pr-7 text-sm font-medium text-neutral-800 focus:border-brand-400 focus:outline-none"
          >
            {episodes.map((e) => (
              <option key={e.episodeIndex} value={e.episodeIndex}>
                第 {e.episodeIndex} 集{e.title ? ` · ${e.title}` : ''}
              </option>
            ))}
          </select>
          <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-neutral-400" />
        </div>
        <span className="text-xs text-neutral-400">
          {scenes.length} 个场景
        </span>
      </div>

      {scenes.length > 0 && (
        <div className="-mx-1 flex gap-1.5 overflow-x-auto px-1 pb-1">
          {scenes.map((sc) => {
            const active = sc.sceneId === sceneId;
            return (
              <button
                key={sc.sceneId}
                type="button"
                onClick={() => onSceneChange(sc.sceneId)}
                className={
                  'shrink-0 rounded-full border px-3 py-1 text-xs font-medium transition ' +
                  (active
                    ? 'border-brand-500 bg-brand-500 text-white shadow-sm'
                    : 'border-outline-variant/40 bg-surface text-neutral-700 hover:border-brand-300 hover:text-brand-600')
                }
              >
                {sc.sceneId}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
